import React, { FC } from 'react';
import { SingleNoteItem } from './SingleNoteItem';
import { InsuranceDoctorNoteDto } from '@apiModels/Insurance/InsuranceDoctorNoteDto.csharp';

interface NotesListProps {
  notes: InsuranceDoctorNoteDto[];
  onEditNoteSubmit: (noteId: string, noteText: string, cb: (status: 'error' | 'success') => void) => void;
  onDeleteNote: (noteId: string, cb: (status: 'error' | 'success') => void) => void;
}

export const NotesList: FC<NotesListProps> = (props) => {
  const { notes, onEditNoteSubmit, onDeleteNote } = props;

  return (
    <ul className="notesList">
      {notes.map((note) => (
        <SingleNoteItem note={note} key={note.id} onEditNoteSubmit={onEditNoteSubmit} onDeleteNote={onDeleteNote} />
      ))}
    </ul>
  );
};
